export const EMAIL_TYPE_MAP = {
  727530000: "Primary Email",
  727530001: "Alternate Email",
  727530002: "Billing Email",
};
